import Cookie from 'js-cookie';
var getCookie = function () { return ({
    JobseekerSessionId: Cookie.get('JobseekerSessionId'),
    isSplitRegister: Cookie.get('split-register-flow'),
}); };
export var deployCookieMonster = function () {
    var allCookies = Cookie.get();
    for (var _i = 0, _a = Object.keys(allCookies); _i < _a.length; _i++) {
        var cookie = _a[_i];
        if (cookie.includes('a0.spajs.txs')) {
            Cookie.remove(cookie);
        }
    }
};
export default getCookie;
//# sourceMappingURL=cookie.js.map